<section class="sorteo-egresados-anahuac so3" style="background-image: url(/assets/images/sorteo2025/banner-sa.jpg);">
    <div class="container">
        <div class="row">



            <!-- <div class="col-md-6 my-auto mx-auto text-center">
                <h1 style="font-size: 40px;">
                    CONOCE


                    <span class="paragraph d-block" style="font-size: 40px;">
                        A NUESTROS

                    </span>

                    <span class="text d-block">
                        GANADORES
                    </span>
                </h1>

                <p>
                    2° SORTEO OPORTUNO
                </p>
            </div>

            <div class="col-md-6 my-auto">
                <img src="/assets/images/sorteo2025/oportuno/man2.png" class="img-fluid d-md-block d-none">
            </div> -->

            <div class="col-md-12 text-center my-auto">
                <h1>
                    <span class="paragraph d-block mx-auto">
                        CONOCE A NUESTROS
                    </span>
                    GANADORES DEL <img src="/assets/images/sorteo2025/logo-banner.png" alt="Sorteo Aniversario"
                        class="img-fluid mx-auto">
                </h1>

                <img src="/assets/images/sorteo2025/autos-banner.png" alt="Sorteo Aniversario"
                    class="img-fluid d-md-block d-none">
            </div>

        </div>
    </div>
</section>

<section class="stc-winners-opt so3">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color: #0f6d4b !important;">
                    LISTA OFICIAL DE GANADORES
                    <span class="d-block">
                        SORTEO ANÁHUAC ANIVERSARIO
                    </span>
                </h2>
            </div>
            <div class="col-md-12 ">
                <div class=" text-center" style="overflow-x: auto;">

                    <table class="table table-striped ">

                        <thead class="text-center">
                            <tr class="text-center">
                                <th class="border-none" colspan="4">Compradores</th>
                                <th class="border-none" colspan="3">Colaboradores</th>
                            </tr>
                            <tr class="text-center cols">
                                <th scope="col"><span>No. DE PREMIO</span></th>
                                <th scope="col"><span>nombre</span></th>
                                <th scope="col"><span>PREMIO</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO</span></th>
                                <th scope="col"><span>NOMBRE</span></th>
                                <th scope="col"><span>PREMIO</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO </span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center first">
                                <td>1</td>
                                <td>Jesus E. M.</td>
                                <td>Auto Modelo 2025 Audi - Q7</td>
                                <td>011706</td>
                                <td>Jesus E. M.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 011706</td>
                            </tr>

                            <tr class="text-center first">
                                <td>2</td>
                                <td>Sandra Lorena F. C.</td>
                                <td>Auto Modelo 2023 BYD - Tang EV</td>
                                <td>015167</td>
                                <td>Pablo G. V.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 015167</td>
                            </tr>


                            <tr class="text-center first">
                                <td>3</td>
                                <td>M. Jaqueline S. C. </td>
                                <td>Auto Modelo 2025 Audi - Q3 </td>
                                <td>017803</td>
                                <td>Adriana Maria M. M.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 017803</td>
                            </tr>


                            <tr class="text-center first">
                                <td>4</td>
                                <td>Ruben Alberto Ch. K. </td>
                                <td>Auto Modelo 2025 BYD - Yuan Pro </td>
                                <td>032687</td>
                                <td>Diana Crecencia I. C.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 032687</td>
                            </tr>

                            <tr class="text-center first">
                                <td>5</td>
                                <td>Renata Isabel V. G. </td>
                                <td>Auto Modelo 2025 BYD - Yuan Pro </td>
                                <td>032165</td>
                                <td>Renata Isabel V. G.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 032165</td>
                            </tr>


                            <tr class="text-center first">
                                <td>6</td>
                                <td>Josefina Silvia Z. M. </td>
                                <td>Auto Modelo 2025 BYD - King </td>
                                <td>032730</td>
                                <td>Zandra Verónica D. R.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 032730</td>
                            </tr>

                            <tr class="text-center first">
                                <td>7</td>
                                <td>NO CONCENTRADO</td>
                                <td>Auto Modelo 2025 BYD - King </td>
                                <td>032820</td>
                                <td>NO CONCENTRADO</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>NO CONCENTRADO</td>
                            </tr>

                            <tr class="text-center first">
                                <td>8</td>
                                <td>Christian. H. S.</td>
                                <td>Auto Modelo 2025 BYD - King </td>
                                <td>006660</td>
                                <td>Pablo G. V.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 006660</td>
                            </tr>

                            <tr class="text-center first">
                                <td>9</td>
                                <td>Iván Eduardo R. S.</td>
                                <td>Auto Modelo 2025 BYD - Dolphin Mini </td>
                                <td>037185</td>
                                <td>Iván Eduardo R. S.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 037185</td>
                            </tr>

                            <tr class="text-center first">
                                <td>10</td>
                                <td>Victor Manuel S. C.</td>
                                <td>Auto Modelo 2025 BYD - Dolphin Mini </td>
                                <td>037298</td>
                                <td>José R.</td>
                                <td>Viaje a Europa para dos personas durante 10 dias</td>
                                <td>POR VENDER EL BOLETO 037298</td>
                            </tr>




                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12 footer-egr">
                <p class="font-bold">
                    SORTEO ANÁHUAC ANIVERSARIO
                </p>

                <p>
                    El Sorteo Anáhuac celebró el día jueves 18 de septiembre de 2025, a las 16:30 horas, el SORTEO
                    ANÁHUAC ANIVERSARIO, en las Instalaciones de la Universidad Anáhuac México Campus Norte con
                    domicilio en la Ave. Universidad 46 Huixquilucan, Estado de México. C.P. 52786 con la presencia del
                    <strong class="f-bold"> C. Ulises Raymundo Martínez Villaverde Martínez</strong>, Inspector asigando
                    por la Dirección General de Juegos y Sorteos, para dar fe y
                    legalidad del evento.
                </p>

                <p>
                    De acuerdo con lo establecido en el Permiso No. 20250348PS02 otorgado por la Secretaría de
                    Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores directos, así como los nombres
                    de los colaboradores que se han hecho acreedores a un premio por haber vendido los boletos del
                    premio uno al diez, han de ser publicados de forma posterior al evento del sorteo en la página de
                    internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 20 de septiembre
                    de 2025 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el nombre propio de los ganadores,
                    completándose con las iniciales de cada uno de los apellidos, y adicionalmente, se publicará la
                    lista con los nombres completos de los ganadores en las Instalaciones de la Universidad Anáhuac
                    México Campus Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786,
                    Huixquilucan Estado de México.
                </p>

                <p>

                    Venta directa desde www.sorteoanahuac.mx /Colaborador Institucional responsable: Pablo Galindo Vega.
                    Los boletos vendidos directamente desde la página web no cuentan con un colaborador individual
                    sujeto a beneficios en premios, sino a un colaborador institucional responsable cuyo nombre aparece
                    en el listado. Los premios para colaborador, en estos casos, son dados automáticamente al programa
                    de becas de la Red de Universidades Anáhuac.  No Concentrado. Es un premio que definirá la autoridad
                    con base a lo que ocurre cuando el número de boleto ganador cae en un boleto no concentrado, por lo
                    que se genera un número de reserva. 
                    Los premios mayores a 1,500 (UMA), $169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos
                    00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de los mismos,
                    conforme al siguiente calendario de fechas:


                </p>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">FECHA DEL EVENTO</th>
                            <th scope="col">HORA DEL EVENTO</th>
                            <th scope="col">LUGAR DEL EVENTO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td> 02 de octubre de 2025</td>
                            <td>10:00 horas</td>
                            <td>Entrega de los Premios del 1 al 10 de Comprador del SORTEO ANÁHUAC ANIVERSARIO, se
                                llevará a cabo en las Instalaciones de la Universidad Anáhuac México Campus Norte con
                                domicilio en Av. Universidad Anáhuac 46 Huixquilucan, Estado de México. C.P. 52786.</td>
                        </tr>

                    </tbody>
                </table>



                <p>
                    Para recibir sus premios, los ganadores deberán mostrar en caso de tener un boleto físico, la parte
                    del contra talón (boleto original) con el número ganador e identificación oficial vigente con
                    fotografía. Para el caso de los boletos digitales, el ganador solamente deberá mostrar por medio de
                    su aparato móvil la imagen del boleto digital con el número ganador que le llegó vía correo
                    electrónico al hacer la compra de su boleto y su identificación oficial vigente con fotografía.
                </p>


                <p>
                    Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo.
                    Los premios menores a 1,500 (UMA) , 169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos
                    00/100 m.n.) se realizará dentro de los 20 (veinte) días hábiles contados a partir de la celebración
                    del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan,
                    Estado de México, piso 6 del edificio de Biblioteca, en horario de lunes a jueves de 10:00 a 18:00
                    hrs. y los viernes de 10:00 a 14:00 hrs. Para más información sobre dónde reclamar la entrega de los
                    premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del
                    Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P.
                    52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 7474.

                </p>

                <p>

                    Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con
                    fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses), Constancia
                    de situación fiscal (mes en curso) y CURP; el nombre completo escrito en el boleto debe corresponder
                    exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y su identificación
                    oficial.


                </p>

                <p> En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos
                    y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez,
                    Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.</p>
                <p>
                    <strong>PERMISO SEGOB: 20250034PS02</strong>
                </p>
            </div>

        </div>
    </div>
</section>